import { parse, areIntervalsOverlapping } from 'date-fns';
import type { Course } from '../types/course';

export function doTimesOverlap(time1: string, time2: string): boolean {
  const [start1, end1] = time1.split(' - ');
  const [start2, end2] = time2.split(' - ');

  const baseDate = new Date();
  const interval1 = {
    start: parse(start1, 'HH:mm', baseDate),
    end: parse(end1, 'HH:mm', baseDate)
  };
  const interval2 = {
    start: parse(start2, 'HH:mm', baseDate),
    end: parse(end2, 'HH:mm', baseDate)
  };

  return areIntervalsOverlapping(interval1, interval2);
}

export function findOverlappingCourses(courses: Course[]): Set<string> {
  const overlappingIds = new Set<string>();
  
  for (let i = 0; i < courses.length; i++) {
    for (let j = i + 1; j < courses.length; j++) {
      if (courses[i].date === courses[j].date && doTimesOverlap(courses[i].time, courses[j].time)) {
        const id1 = `${courses[i].date}-${courses[i].time}-${courses[i].course_name}`;
        const id2 = `${courses[j].date}-${courses[j].time}-${courses[j].course_name}`;
        overlappingIds.add(id1);
        overlappingIds.add(id2);
      }
    }
  }
  
  return overlappingIds;
}